<template>
  <pt-withdraw-detail class="pt-withdraw-detail__page" :id="id"></pt-withdraw-detail>
</template>

<script>
import PtWithdrawDetail from 'cps/new-to-old-audit/pt-withdraw-audit/pt-withdraw-detail/withData'
export default {
  name: 'pt-withdraw-detail__view',
  components: {
    'pt-withdraw-detail': PtWithdrawDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
